import { render, staticRenderFns } from "./MarkdownHelp.vue?vue&type=template&id=284aa82d"
import script from "./MarkdownHelp.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkdownHelp.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports